import { Box, Paper, Tab, Tabs } from "@mui/material"
import React from "react"

import type { Pool } from "@/api/pools-api"

import BuyOnBark from "@/components/TradeOnBark/Buy"
import SellOnBark from "@/components/TradeOnBark/Sell"

interface TabPanelProps {
  children?: React.ReactNode
  dir?: string
  index: number
  value: number
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Paper sx={{ p: 2 }}>{children}</Paper>}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  }
}

export function TradeOnBark({
  pool,
  handleForceRefresh,
}: {
  pool: Pool
  handleForceRefresh: (force: boolean) => void
}) {
  const [tab, setTab] = React.useState(0)

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue)
  }

  return null

/*   return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Paper>
          <Tabs
            value={tab}
            onChange={handleChangeTab}
            indicatorColor="secondary"
            textColor="inherit"
            variant="fullWidth"
            aria-label="full width tabs example"
          >
            <Tab label="Buy" {...a11yProps(0)} />
            <Tab label="Sell" {...a11yProps(1)} />
          </Tabs>

          <TabPanel value={tab} index={0}>
            <BuyOnBark pool={pool} handleForceRefresh={handleForceRefresh} />
          </TabPanel>
          <TabPanel value={tab} index={1}>
            <SellOnBark pool={pool} handleForceRefresh={handleForceRefresh} />
          </TabPanel>
        </Paper>
      </Box>
    </>
  ) */
}
